import { createConfetti } from "../utils/confetti.ts";

// Checklist Automation
export function initChecklistAutomation(): void {
  // Get all phase sections (details elements with gradient backgrounds)
  const phases = document.querySelectorAll(
    "details.bg-gradient-to-r",
  );

  phases.forEach((phase) => {
    const phaseElement = phase as HTMLElement;
    const summary = phaseElement.querySelector("summary");
    const sectionCheckbox = summary?.querySelector(
      'input[type="checkbox"]',
    ) as HTMLInputElement;

    if (!sectionCheckbox) return;

    // Get all subsection checkboxes within this phase
    const itemCheckboxes = phaseElement.querySelectorAll(
      'tbody tr input[type="checkbox"]',
    ) as NodeListOf<HTMLInputElement>;

    // Function to check if all items are checked
    const updateSectionCheckbox = () => {
      const allChecked = Array.from(itemCheckboxes).every((cb) => cb.checked);
      const wasUnchecked = !sectionCheckbox.checked;

      if (allChecked && itemCheckboxes.length > 0) {
        sectionCheckbox.checked = true;
        // Trigger confetti if this is a new completion
        if (wasUnchecked) {
          createConfetti(sectionCheckbox);
        }
      } else {
        sectionCheckbox.checked = false;
      }
    };

    // Add listeners to all item checkboxes
    itemCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", updateSectionCheckbox);
    });

    // Add listener to section checkbox for manual checking
    sectionCheckbox.addEventListener("change", (_e) => {
      if (sectionCheckbox.checked) {
        createConfetti(sectionCheckbox);
      }
    });

    // Initial check
    updateSectionCheckbox();
  });
}
